import cb from '@/assets/modules/constraints/constraintBuilder'
import dc from '@/assets/modules/events/discountCalculator'

export default {

  /**
   * Creates a MPE payload object for a given post type
   * @param {Object} postFields Object of post fields
   * @param {String} channelPostType Channel type
   * @param {String} postType Post type (product, post, etc)
   * @param {Array} media Array f media
   */
  makePayload (postFields, channelPostType, postType, media) {
    let typeSpecificField = postFields[postType] || {}
    const { relative } = dc.getDiscount(typeSpecificField.discount)

    let dsc = typeSpecificField.content || typeSpecificField.description || ''

    // Makes a payload structure based on channel type.
    switch (channelPostType) {
      case 'facebookPost':
        return {
          message: dsc,
          link: postFields.url,
          photos: media
        }

      case 'sqwizProduct':
        return {
          title: postFields.label,
          descriptionShort: dsc.split('\n').join('<br>'),
          price: typeSpecificField.price,
          discountPercent: relative ? typeSpecificField.discount * 100 : Math.abs(typeSpecificField.discount / typeSpecificField.price) * 100,
          images: media
        }

      case 'sqwizArticle':
        return {
          title: postFields.label,
          body: dsc.split('\n').join('<br>'),
          images: media
        }

      case 'shopamineProduct':
        return {
          name: postFields.label,
          model: postFields.model,
          shortDescription: dsc,
          price: typeSpecificField.price,
          discount: typeSpecificField.discount,
          images: media
        }

      case 'informacijaPost':
        return {
          name: postFields.label,
          shortDescription: dsc.split('\n').join('<br>'),
          images: media
        }

      case 'informacijaProduct':
        return {
          name: postFields.label,
          model: postFields.model,
          shortDescription: dsc.split('\n').join('<br>'),
          price: typeSpecificField.price,
          discount: relative ? typeSpecificField.discount * 100 : Math.abs(typeSpecificField.discount / typeSpecificField.price) * 100,
          images: media
        }

      case 'informacijaPost':
        return {
          name: postFields.label,
          shortDescription: dsc,
          images: media
        }

      case 'twitterTweet':
        let status = `${dsc || ''}`
        return {
          status,
          media: media
        }

      case 'pinterestPin':
        return {
          note: dsc,
          link: postFields.url,
          image: media
        }

      case 'wordpressPost':
        return {
          title: postFields.label,
          content: dsc,
          media
        }

      case 'woocommerceProduct':
        const { new: salePrice, discount } = dc.calculate({}, typeSpecificField)
        return {
          name: postFields.label,
          shortDescription: dsc,
          // TODO: Currently only short desc is used.
          description: undefined,
          regularPrice: typeSpecificField.price ? `${typeSpecificField.price}` : undefined,
          salePrice: discount ? `${salePrice}` : undefined,
          // TODO:
          categories: undefined,
          images: media
        }
    }
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/assets/modules/channels/mpeeFieldBuilder.js